module.exports = __webpack_public_path__ + "img/Garuda-logo-symbol.87c59d59.png";